import React from "react";
import { Skeleton } from "@mui/material";
import PropTypes from "prop-types";

// Using sx prop instead of styled components
export const SkeletonLoader = props => {
  return (
    <Skeleton
      variant="rectangular"
      sx={{
        width: "100%",
        height: "56px",
        borderRadius: "8px",
        marginBottom: "24px",
        ...(props.sx || {})
      }}
      {...props}
    />
  );
};

SkeletonLoader.propTypes = {
  sx: PropTypes.object
};
